var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgUmbrella = function SvgUmbrella(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "umbrella_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 19a3 3 0 0 1-6 0v-7m11 0a11.05 11.05 0 0 0-22 0h22Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export { SvgUmbrella as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNMTggMTlDMTggMTkuNzk1NiAxNy42ODM5IDIwLjU1ODcgMTcuMTIxMyAyMS4xMjEzQzE2LjU1ODcgMjEuNjgzOSAxNS43OTU2IDIyIDE1IDIyQzE0LjIwNDQgMjIgMTMuNDQxMyAyMS42ODM5IDEyLjg3ODcgMjEuMTIxM0MxMi4zMTYxIDIwLjU1ODcgMTIgMTkuNzk1NiAxMiAxOVYxMk0yMyAxMkMyMi43Mzg4IDkuMjYzNTcgMjEuNDY3IDYuNzIyNzUgMTkuNDMzIDQuODczNjZDMTcuMzk5IDMuMDI0NTggMTQuNzQ4OSAyIDEyIDJDOS4yNTExNCAyIDYuNjAwOTYgMy4wMjQ1OCA0LjU2Njk3IDQuODczNjZDMi41MzI5NyA2LjcyMjc1IDEuMjYxMiA5LjI2MzU3IDEgMTJIMjNaIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48L3N2Zz4=";